<template>
  <div class="data-cate">
    <Card style="width:100%">
      <Row style="border-bottom:1px solid #F3F4F5;height:40px;line-height:40px">
        <Col :xs="11"
             :sm="11">试玩抽取最多次数</Col>
        <Col :xs="11"
             :sm="11">
        <Input v-model="shiwanlingqutimes"
               placeholder="请输入次数"
               style="width: 100%;height:40px;line-height:40px" /></Col>
      </Row>
      <Row style="border-bottom:1px solid #F3F4F5;height:40px;line-height:40px">
        <Col :xs="11"
             :sm="11">幸运抽取最多次数</Col>
        <Col :xs="11"
             :sm="11">
        <Input v-model="lingqutimes"
               placeholder="请输入次数"
               style="width: 100%;height:40px;line-height:40px" /></Col>
      </Row>
      <Row style="border-bottom:1px solid #F3F4F5;height:40px;line-height:40px">
        <Col :xs="11"
             :sm="11">概率名称</Col>
        <Col :xs="11"
             :sm="11">抽中概率</Col>
      </Row>
      <Row style="height:40px;margin-top:10px"
           v-for="(item,index) in ruleList">
        <Col :xs="11"
             :sm="11"
             style="padding-right:20px">
        <Input v-model="item.attr_name"
               placeholder="请输入属性名"
               style="width: 100%;height:40px;line-height:40px" />
        </Col>
        <Col :xs="11"
             :sm="11"
             style="padding-right:20px">
        <Input v-model="item.percent"
               placeholder="请输入概率"
               style="width: 100%;height:40px;line-height:40px" />
        </Col>
        <Col :xs="2"
             :sm="2">
        <Icon type="md-trash"
              size="30"
              style="margin-top:5px"
              @click="deleteRule(index)" />
        </Col>
      </Row>
      <div class="action_back">
        <Button type="success"
                @click="saveRule"
                :loading="loading">保存</Button>
        <Button type="info"
                style="margin-right:20px"
                @click="addGoodRule">添加</Button>
      </div>
    </Card>
  </div>
</template>
  
  <script>
import UploadThumb from "../../common/thumb";
export default {
  name: "data-cate",
  data () {
    return {
      loading: false,
      dataloading: true,
      lingqutimes: 1,
      shiwanlingqutimes: 1,
      ruleList: []
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb
  },
  methods: {
    // 获取产品类别列表
    getTableList: function () {
      var that = this;
      this.$api.baixingqiangchouqurule.list().then(res => {
        that.dataloading = false;
        if (res.code == 200) {
          that.ruleList = res.result.attr;
          that.lingqutimes = res.result.times;
          that.shiwanlingqutimes = res.result.shiwantimes;
        }
      });
      return;
    },
    addGoodRule () {
      this.ruleList.push({
        attr_name: null,
        percent: null
      });
    },
    deleteRule (index) {
      var that = this;
      var rule = that.ruleList[index];
      if (
        (rule.attr_name == null ||
          rule.attr_name == undefined ||
          rule.attr_name == "") &&
        (rule.percent == null ||
          rule.percent == undefined ||
          rule.percent == "") &&
        (rule.id == null || rule.id == undefined || rule.id == "")
      ) {
        that.realDeleteRule(index);
        return;
      }
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          that.realDeleteRule(index);
        }
      });
    },
    realDeleteRule (index) {
      var that = this;
      var rule = that.ruleList[index];
      if (rule.id && rule.id != undefined && rule.id != "") {
        var params = {
          id: rule.id
        };
        that.$api.baixingqiangchouqurule.remove(params).then(res => {
          that.dataloading = false;
          if (res.code == 200) {
            that.$Message.success(res.msg);
            that.ruleList.splice(index, 1);
          } else {
            that.$Message.error(res.msg);
          }
        });
      } else {
        that.ruleList.splice(index, 1);
        that.$Message.success("删除成功");
      }
    },
    saveRule () {
      var that = this;
      for (let i = 0; i < this.ruleList.length; i++) {
        const rule = this.ruleList[i];
        if (
          rule.percent == null ||
          rule.percent == undefined ||
          rule.percent == "" ||
          rule.percent.match(/^[ ]*$/)
        ) {
          that.$Message.error("概率不能为空");
          return;
        }
        if (rule.percent < 0) {
          that.$Message.error("概率不能为负数");
          return;
        }
      }
      var params = {
        attrs: this.ruleList,
        lingqutimes: this.lingqutimes,
        shiwanlingqutimes: this.shiwanlingqutimes
      };

      that.loading = true;
      this.$api.baixingqiangchouqurule.change(params).then(res => {
        if (res.code == 200) {
          this.getTableList();
          this.$Message.success(res.msg);
        } else {
          this.$Message.error(res.msg);
        }
        that.loading = false;
      });
    }
  }
};
  </script>
  <style scoped>
.action_back {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;
}
</style>